export const AGGREGATION_TYPES = {
    MEASURE: 'measure',
    DIMENSION: 'dimension',
};

export class AggregationModel {
    label = '';
    searchTerms = '';

    constructor(label, searchTerms = [], sqlFn = column => column.sqlName) {
        this.label = label;
        this.searchTerms = `${searchTerms.join(' ')} ${label}`;
        this.sqlFn = sqlFn;
    }

    matchesQuery(searchQuery) {
        const regex = new RegExp(searchQuery, 'i');
        return regex.test(this.searchTerms);
    }

    getSql(column) {
        return this.sqlFn(column);
    }
}

export class MeasureAggregationModel extends AggregationModel {
    type = AGGREGATION_TYPES.MEASURE;
}

export class DimensionAggregationModel extends AggregationModel {
    type = AGGREGATION_TYPES.DIMENSION;
}
